import { required } from 'utils/formValidators';
import { formatValidationMap } from 'config/fieldFormatValidationConfig';

const getSurveyBlockValidationList = (isRequired, format) => {
  const validatorList = [];
  const formatValidator = formatValidationMap[format];
  if (isRequired) {
    validatorList.push(required('Required question'));
  }
  if (formatValidator) {
    validatorList.push(formatValidator());
  }
  return validatorList;
};

export default getSurveyBlockValidationList;
